import { Injectable } from "@angular/core";
import DevExpress from "devextreme";
import dxScrollView = DevExpress.ui.dxScrollView;

@Injectable({
  providedIn: "root",
})

/*
  Service to share the dxScrollView instance across components.
  This allows different parts of the application to access and manipulate
  the scroll view as needed.
 */
export class ScrollService {
  get scrollViewInstance(): dxScrollView {
    return this._scrollViewInstance;
  }

  set scrollViewInstance(value: dxScrollView) {
    this._scrollViewInstance = value;
  }

  private _scrollViewInstance: dxScrollView;

  constructor() {}
}
